import { NgControl } from "@angular/forms";
import { AfterViewInit, Directive, ElementRef, Input, Renderer2, OnDestroy } from '@angular/core';

@Directive({
    selector: '[appValidateInput]',
    standalone: true
})
export class ValidateInputDirective implements AfterViewInit, OnDestroy {

    @Input() skipBlurValidationIfEmpty = true;
    @Input()
    set checkValidation(value: boolean) {
        if (value) { setTimeout(() => this.handle()); }
    }
    input: HTMLInputElement;
    controlSubscribe: any;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private control: NgControl) { }

    ngAfterViewInit(): void {
        this.input = this.el.nativeElement;
        this.input.addEventListener('blur', this.handle.bind(this));
        this.controlSubscribe =
            this.control.valueChanges?.subscribe((res) => {
                this.check()
            });
    }

    ngOnDestroy() {
        this.controlSubscribe.unsubscribe();
    }

    private check(): void {
        if (this.control.valid) {
            this.renderer.removeClass(this.input, 'uk-form-danger');
        }
    }

    private handle(event?: Event): void {
        if (this.skipBlurValidationIfEmpty && event?.type === 'blur' &&
            !this.input.value) {
            return;
        }
        if (!this.control.valid && !this.control.disabled) {
            this.renderer.addClass(this.input, 'uk-form-danger');
        }
    }
}